import { combineReducers } from 'redux';
import { orderBy } from 'lodash';
import { FETCH_QUEUE_JOBS } from './constants';

const jobs = (state = [], { type, payload }) => {
  switch (type) {
    case FETCH_QUEUE_JOBS:
      return orderBy(payload || [], ['createdAt'], ['desc']);
    default:
      return state;
  }
};

const reducer = combineReducers({ jobs });

export default reducer;
